export default {
  data() {
    return {
      contatos: [],
    };
  },
  methods: {
    confirmarContato(contato) {
      if (!contato.id) {
        contato.id = new Date().getTime();
        this.contatos.push(contato);
      } else {
        this.contatos = this.contatos.map((c) =>
          c.id === contato.id ? contato : c
        );
      }
    },
  },
};
